// test1996
(1996 && 0);
